import React, { useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { Button } from 'antd';
import GhatikLogo2 from "../../Images/GhatikLogo2.png";

const DirectFinanceScheme = () => {
  const navigate = useNavigate();
  useEffect(() => {
    // Scroll to the top of the page when this component is mounted
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ maxWidth: "800px", margin: "0 auto", padding: "20px", background: "#fff", fontFamily: "Arial, sans-serif" }}>
      <div style={{ display: "flex", alignItems: "center", marginBottom: "20px" }}>
            <img 
                src={GhatikLogo2} 
                alt="Logo" 
                style={{ width: "50px", height: "50px", objectFit: "contain", marginRight: "10px" }} 
            />
            <h1 style={{ fontSize: "24px", fontWeight: "bold", color: "red", margin: 0 }}>
                MARGIN MONEY SCHEME
            </h1>
        </div>

      <p style={{ fontSize: "14px", color: "#333", textAlign: "left", fontWeight: "bold", marginBottom: "10px" }}>
        Procedures to be followed while implementing seed capital scheme
      </p>
      <p style={{ fontSize: "12px", color: "#777",  textAlign: "left",marginBottom: "20px" }}>
        * Various schemes are implemented through Mahatma Phule Backward Development Corporation. In this, seed capital scheme is being implemented and under this scheme Rs. 50,000 to a maximum of Rs. 1,00,000/- are sanctioned through nationalized banks. In this, the bank loan is 75% and the corporation loan is 20% and the applicant participates in the remaining 5%.
      </p>
      <p style={{ fontSize: "12px", color: "#777",  textAlign: "left",marginBottom: "20px" }}>
        * While implementing the said scheme through the corporation, the necessary documents are taken from the beneficiary and accordingly suitable proposals are sent to the bank. After receiving the loan approval from the bank in such cases, a check of 20% of the total loan amount approved by the bank through the corporation (including subsidy of Rs. 10,000/-) is sent to the concerned bank to disburse the loan to the applicant. This is how the loan case is processed under the seed capital scheme. Following are the details of the documents to be taken while accepting the application and sending it to the bank.
      </p>
      <p style={{ fontSize: "12px", color: "#777",  textAlign: "left",marginBottom: "20px" }}>
        Under this scheme Rs. Projects with investment up to 5 lakhs are considered. 20% seed capital amount (including subsidy of Rs.10,000/-) is provided by the corporation. 5% of the project is to be paid by the applicant as own contribution. The remaining 75% amount is sanctioned by the bank. A rate of interest of 4% is charged on the seed capital amount sanctioned by the Corporation. The recovery period is five years.
      </p>
      <p style={{ fontSize: "14px", color: "#333",  textAlign: "left",fontWeight: "bold", marginBottom: "10px" }}>
        A) Documents required for loan approval.
      </p>
      <ol style={{ fontSize: "12px", color: "#555",  textAlign: "left",marginBottom: "20px", paddingLeft: "20px" }}>
        <li>1.Caste certificate.</li>
        <li>2.Proof of income.</li>
        <li>3.Resident Proof (Ration Card, Voter ID Card, Aadhaar Card, PAN Card, Electric Bill etc).</li>
        <li>4.Documents related to the business like, price list of goods, proof of place of business if required, clerk license, other documents as per business like license for vehicle, clerk license, batch number etc.</li>
        <li>5.Project report as required (above Rs. 2.00 lakh)</li>
      </ol>
      <p style={{ fontSize: "14px", color: "#333", textAlign: "left", fontWeight: "bold", marginBottom: "10px" }}>
        B) After fulfilling the required documents, the following action is taken by the concerned district office.
      </p>
      <ol style={{ fontSize: "12px", color: "#555",  textAlign: "left",marginBottom: "20px", paddingLeft: "20px" }}>
        <li>1.Applicant's residence as well as place of business are verified.</li>
        <li>2.After that, the loan cases received are scrutinized and approved through the District Beneficiary Selection Committee established under the chairmanship of Hon'ble District Magistrate.</li>
        <li>3.The loan cases approved in the District Beneficiary Selection Committee are recommended to the Nationalized Bank.</li>
        <li>4.After approval of such cases from the nationalized banks, necessary documents from the applicant in accordance with the disbursement of seed capital loan of the corporation (such as medical certificate, guarantor, guarantor's salary deduction certificate, asset record document if the property holder is a guarantor, guarantor verification report, election card of the guarantor, etc.) issued identity card as well as the applicant's reply dated check etc.) along with loan recovery.</li>
        <li>5.In such sanctioned loan case after completion of all necessary documents of guarantors etc. before disbursement of loan, the loan subsidy is submitted to the Regional Manager.</li>
        <li>6.After receiving the approval for disbursement of loan from the Regional Manager, separate checks for seed capital (loan) and subsidy are drawn and sent to the bank in accordance with the disbursement through the concerned District office.</li>
      </ol>
      <div style={{ textAlign: "left",  }}>
        <Button
          type="primary"
          style={{ background: "#1e40af", borderColor: "#1e40af",  fontSize: "14px" }}
          onClick={() => navigate("/apply")}
        >
          Apply
        </Button>
      </div>
    </div>
  );
};

export default DirectFinanceScheme;